import React, { useEffect, useState } from "react";
import "../../CSS/CanEmpl.css";
import { useLocation } from "react-router-dom"
import { API_BASE_URL } from "../../config/serverApiConfig";
import { Toaster, toast } from "react-hot-toast";
import Loader from "../../components/Loader/loader";
import Select, { StylesConfig } from "react-select";
import chroma from "chroma-js";
import { ColourOption } from "../../Selecteddata/data";
import ErrorLoader from "../../components/Loader/SearchBarError";
import Error404Loader from "../../components/Loader/404Error";
import Cookies from "js-cookie";
import CandidateProfileCard from "../../components/candidate/cards/CandidateProfileCard";
import CandidateFilters from "../../components/candidate/filters/candidateFilters";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      lable: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

function CandidateList() {
  const location = useLocation();
  const status = location.state?.status || null;

  const [filters, setFilters] = useState({
    candidatLicensePermis: null,
    candidatLanguages: null,
    enteredBy: null,
    candidatStatus: status,
  });
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const [filterData, setFilterData] = useState([]) as any;
  const [page, setPage] = useState(0);
  const [readyToWorkLength, setreadyToWorkLength] = useState({
    length: 0,
    readyToWorkLength: 0
  })
  const [candidateProfiles, setCandidateProfiles] = useState([]);
  const [candidateCountMatchingFilter, setCandidateCountMatchingFilter] = useState();

  const handleFilterChange = (filterName, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: value ? value : null,
    }));
  };

  const loadMoreHandle = (i: any) => {
    let isNearBottom = i.target.scrollHeight - i.target.clientHeight - i.target.scrollTop < 50;

    if (isNearBottom) {
      setPage((prevPage) => prevPage + 20);
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const isFiltersEmpty = (filters) => {
      return Object.values(filters).every((value) => value === null);
    };

    if (!isFiltersEmpty(filters)) {
      fetchFilteredProfiles(page, signal);
    } else {
      fetchUnfilteredProfiles(page, signal);
    }

    return () => {
      controller.abort();
    };
  }, [page]);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const isFiltersEmpty = (filters) => {
      return Object.values(filters).every((value) => value === null);
    };

    setPage(0);
    if (!isFiltersEmpty(filters)) {
      fetchFilteredProfiles(page, signal);
    } else {
      fetchUnfilteredProfiles(page, signal);
    }

    return () => {
      controller.abort();
    };
  }, [filters]);

  const fetchUnfilteredProfiles = async (page, signal) => {
    setLoader(true);

    try {
      const response = await fetch(API_BASE_URL + `getCandidats${page ? `?skip=${page}` : ""}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("token"),
        },
        signal, // Directly pass the signal here
      });

      const reD = await response.json();

      if (page) {
        setCandidateProfiles([...candidateProfiles, ...reD.data]);
      } else {
        setCandidateProfiles([...reD.data]);
      }
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("Error fetching profile:", err);
      }
    } finally {
      setLoader(false);
    }
  };

  const constructEndpointWithParams = (baseUrl, endpoint, filters, page) => {
    // Add the filters to the query params
    const cleanedFilters: any = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value) // Only include non-null filters
    )
    // Initialize URLSearchParams
    const params = new URLSearchParams(cleanedFilters);

    // Add the skip parameter for pagination if it exists
    if (page) {
      params.append('skip', page);
    }

    // Construct the full URL
    return `${baseUrl}${endpoint}?${params.toString()}`;
  };

  const fetchFilteredProfiles = async (page, signal) => {
    setLoader(true);

    try {
      const endpoint = constructEndpointWithParams(API_BASE_URL, 'getCandidats', filters, page);

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("token"),
        },
        signal
      });

      const filteredResponse = await response.json();
      if (page) {
        setCandidateProfiles([...candidateProfiles, ...filteredResponse.data]);
        setCandidateCountMatchingFilter(filteredResponse?.total);
      } else {
        setCandidateProfiles([...filteredResponse.data]);
        setCandidateCountMatchingFilter(filteredResponse?.total);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Toaster
        position="top-right"
        containerStyle={{ zIndex: "99999999999" }}
      />

      <div
        className="container-fluid cardScrollBar"
        onScroll={loadMoreHandle}
        style={{ overflowY: "auto", height: "100vh" }}
      >
        <div className="row pd">
          {/* Info Bar */}
          <div
            className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 card-tops px-1 mt-1"
            style={{ padding: "0px", marginBottom: "20px" }}
          >
            <div className="row text-start">
              <div
                className="card mdquery"
                style={{
                  padding: "15px 15px",
                  borderRadius: "10px",
                  marginBottom: "0px",
                }}
              >
                <div className="d-flex topHeading">
                  {" "}
                  <h2 className="">candidates/employees</h2>{" "}
                </div>
                <p className="h-child-text d-flex mb-0 fw-bold">
                  Here you have the list of candidates not yet working with us
                </p>
                <p className="h-child-text mb-0">
                  You must always ensure that you have as much information as possible on this list and move the candidates to the archive or delete if they are no longer relevant.
                </p>
              </div>
            </div>
          </div>

          {/* Filters */}
          <CandidateFilters onFilterChange={handleFilterChange} />

          {/* Work length section */}
          {
            Object.values(filters).some(value => value !== null) && candidateProfiles.length ?
              <div className="tw-bg-white tw-p-4 tw-my-2 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
                <p className="tw-text-xl">
                  Total <span className="tw-text-red-600 tw-font-bold">{candidateCountMatchingFilter}</span> candidates match your search filters.
                </p>
              </div> :
              ""
          }

          {/* Candidate Profiles */}
          {candidateProfiles.length > 0 ? (
            candidateProfiles.map((profile, index) => (
              <div className="md:tw-w-1/3 3xl:tw-w-1/4 tw-flex tw-my-2" key={index}>
                <CandidateProfileCard data={profile} />
              </div>
            ))
          ) : (
            <div className="tw-w-full tw-justify-center tw-text-gray-500 tw-flex tw-items-center tw-my-10 tw-text-2xl">
              {status ? `No candidates found in this Status.` : 'No Candidates Found.'}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default CandidateList;